<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Setup Bar"
    seFeDataSubtitle="A setup bar component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component as the top bar when displaying setup progress</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="SetupBarComponent"></se-fe-card-header>
      <se-fe-card-content>
        <se-fe-docs-table
          [seFeDataHeaders]="headers"
          [seFeDataRows]="setupBarComponent">
        </se-fe-docs-table>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-setup-bar-example></se-po-setup-bar-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
